import * as itemStyles from "./MenuItem.css";
import * as styles from "./MenuRadioItem.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Menu as BaseMenu } from "@base-ui/react/menu";
import { Icon } from "@frontend/components/atoms/Icon";

import { useMenuContext } from "./Menu.context";
import type { MenuRadioItemProps } from "./Menu.types";

export function MenuRadioItem({
  className,
  children,
  ...props
}: MenuRadioItemProps): JSX.Element {
  const { size } = useMenuContext();

  return (
    <BaseMenu.RadioItem
      data-slot="menu-radio-item"
      className={clsx(itemStyles.item({ size }), className)}
      {...props}
    >
      <BaseMenu.RadioItemIndicator
        data-slot="menu-radio-item-indicator"
        className={styles.indicator}
        keepMounted
      >
        <Icon name="Check" size={size} />
      </BaseMenu.RadioItemIndicator>
      {children}
    </BaseMenu.RadioItem>
  );
}
